module.exports = __webpack_public_path__ + "static/media/0.3b59e622.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/0.png
// module id = 860
// module chunks = 0